/**
 * 资料下载
 */

export const DataDownloadList = [
    {
        prop: "id",
        label: "id",
        width: "150",
        format: "",
        order: false,
        isShow: false
    },
    {
        prop: "userName",
        label: "姓名",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "phone",
        label: "手机号",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "companyName",
        label: "企业名称",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "mail",
        label: "邮箱",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "resourceName",
        label: "文件名称",
        width: "150",
        format: "",
        order: false,
        isShow: true
    },
    {
        prop: "creationTime",
        label: "下载时间",
        width: "150",
        format: "datetime",
        order: false,
        isShow: true
    }
]